/**
 * Behavioral Learning Hook
 * Phase 9.5.2b: Auto-adjusts Smart Swirl weights based on user interactions
 * Runs periodically to keep Smart Swirls self-tuning
 */

import { useEffect } from 'react';
import { FLAGS } from '../lib/flags';
import smartSwirlsService from '../services/smartSwirlsService';

/**
 * Hook that automatically adjusts Smart Swirl weights based on behavioral signals
 * @param {string} userId - User ID
 * @param {number} intervalMinutes - Interval in minutes (default: 30)
 */
export function useBehavioralLearning(userId, intervalMinutes = 30) {
  useEffect(() => {
    // Check if behavioral learning is enabled
    if (!FLAGS.BEHAVIORAL_LEARNING_ENABLED || !userId) {
      return;
    }

    // Initial adjustment on mount
    smartSwirlsService.adjustSmartSwirlWeights(userId).catch(() => {
      // Fail silently
    });

    // Set up interval for periodic adjustments
    const intervalMs = intervalMinutes * 60 * 1000;
    const interval = setInterval(() => {
      smartSwirlsService.adjustSmartSwirlWeights(userId).catch(() => {
        // Fail silently
      });
    }, intervalMs);

    if (import.meta.env.DEV) {
      console.log(`🔄 Behavioral learning active: adjusting weights every ${intervalMinutes} minutes`);
    }

    return () => {
      clearInterval(interval);
    };
  }, [userId, intervalMinutes]);
}

